import { RunContextApp }            from "framework/RCApp";
import { GetApplianceProfile, 
         GetApplianceProfileMetadata, 
         UpdateApplianceProfile 
       }                            from "types/apis/applianceProfileInterfaces";
import { CMSApiResponse }        from "framework/http/CMSApiClient";

export const ApplianceProfileAPI = {

  getApplianceProfileMetadata : async (rc : RunContextApp) : Promise<CMSApiResponse<GetApplianceProfileMetadata.retval>> => {
    const resp = await rc.cmsApiClient.get<GetApplianceProfileMetadata.retval>(`/appliance/getApplianceProfile`)
    return resp
  },

  getApplianceProfile : async (rc : RunContextApp, utilityDocId : string) : Promise<CMSApiResponse<GetApplianceProfile.retval>> => {

    const resp = await rc.cmsApiClient.get<GetApplianceProfile.retval>(`/utility/getApplianceProfile?utilityDocumentId=${utilityDocId}`)
    return resp
  },

  updateApplianceProfile : async (rc : RunContextApp, utilityDocId : string, profileData : UpdateApplianceProfile.params) : Promise<CMSApiResponse<UpdateApplianceProfile.retval>> => {

    const resp = await rc.cmsApiClient.post<UpdateApplianceProfile.retval>(`/utility/updateApplianceProfile`, {
      utilityDocumentId : utilityDocId,
      profile : profileData
    })
    return resp
  }
}